import { type ApiClient, listQueryParams } from "./client";
import type { AuditEvent, AuditEventDetail, AuditFilters, ListQuery, Page } from "./types";

/** Audit: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface AuditApi {
  list(query: ListQuery<AuditFilters>): Promise<Page<AuditEvent>>;
  get(id: string): Promise<AuditEventDetail>;
}

export function createHttpAuditApi(client: ApiClient): AuditApi {
  return {
    list: (q) => client.call("listAuditEvents", { query: listQueryParams(q) }),
    get: (id) => client.call("getAuditEvent", { params: { id } }),
  };
}
